import { CardContent, CardHeader, Stack } from '@mui/material'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Add, FilterAlt } from '@mui/icons-material'
import MaterialButton from '../../../components/MaterialButton'
import MaterialTypography from '../../../components/MaterialTypography'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from '../../../context/popup'
import { useLoading } from '../../../components/Loading'
import Table from '../../../components/Table'
import { useEffect, useState } from 'react'
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import { deleteData, fetchData } from '../../../services/index.js'

const WorkFlowDictionaryList = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showSnackbar } = useSnackbar();
  const { setCircleLoading } = useLoading();

  const currentPage = useSelector((state) => state?.operationWorkflowDictionaryStore?.currentPage);
  const rowsPerPage = useSelector((state) => state?.operationWorkflowDictionaryStore?.rowsPerPage);
  const totalPages = useSelector((state) => state?.operationWorkflowDictionaryStore?.totalPages);

  const [workflowDictionaryData, setWorkflowDictionaryData] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [filterData, setFilterData] = useState({
    isActive: "",
    apiCategoryId: "",
    schemaTypeId: "",
    compatibilityModeId: "",
  });

  useEffect(() => {
    fetchWorkflowDictionaryList();
  },[isRefresh, currentPage, rowsPerPage, search])

  //List API
  const fetchWorkflowDictionaryList = async () => {
      setCircleLoading(true);
      try {
      const response = await fetchData(`/orchestration/work-flow-dictionary?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`)        
      if(response?.success){
          setWorkflowDictionaryData(response?.data?.items);
          dispatch(setTotalPages(response?.data?.totalPages));     
      }
      else{
          //throw error
          showSnackbar("Error Fetching Workflow List", "error")
      }
      } catch (error) {
          console.error('Error Fetching Insurer Api List:', error);
          showSnackbar(error?.message, "error")
      }
      finally{
          setCircleLoading(false);
      }
  };
  
  //delete api function
  const handleDelete = async (row) => {
    try {
        const response = await deleteData(`/api-engine/field-dictionary-delete`, {ids:[row?.id]});
        setIsRefresh(!isRefresh);
        if(response?.success){
            showSnackbar(response?.message, "success");
        }
        else{
            showSnackbar(response?.message, "error");
        }
    } catch (error) {
        console.error("Error deleting data:", error);
        showSnackbar("Error deleting Insurer Registry data", "error");
    }
  };

  //table mapping
  const fieldDictionaryTable = {
      columns: [
          { key: "sno", label: "S.No.", renderCell: (row) => row.sno },            
          { key: "name", label: "Name", renderCell: (row) => row.name },
          { key: "code", label: "Code", renderCell: (row) => row.code },
          { key: "product", label: "Product", renderCell: (row) => row.product },          
          { key: "workflowCategory", label: "Workflow Category", renderCell: (row) => row.workflowCategory },
          {
            key: "isActive",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            )
          },
      ],
      rows: workflowDictionaryData?.map((item, index) => ({
          id: item?.id,
          sno: index + 1,
          name: item?.name || "",
          code: item?.code || "",
          workflowCategory: item?.workflowCategory?.keyName || "",
          product: item?.product?.keyName || "",
          isActive: item?.isActive
      })),
  };

  const actions = {
    edit: true,
    view: true,
    delete: true,

    onEdit: (row) => {
        navigate(`/operation/workflow-dictionary/workflow-dictionary-details?pageType=edit&id=${row.id}`);
    },
    onView: (row) => {
        navigate(`/operation/workflow-dictionary/workflow-dictionary-details?pageType=view&id=${row.id}`);
    },
    onDelete: (row) => handleDelete(row),
  };

  const handlePaginationChange = (page) => {
      dispatch(setCurrentPage(page));
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
      dispatch(setRowsPerPage(rowsPerPage));
      dispatch(setCurrentPage(1));
  };

  const handleSearch = (value) => {
      setSearch(value);
  };

  return (
    <DashboardLayout>
      <CardHeader title={(
        <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        >
            <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                    Workflow Dictionary List
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                    List of Workflow Dictionary.
                </MaterialTypography>
            </Stack>
            <Stack direction="row" spacing={1}>
                <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<FilterAlt />}
                onClick={(event) => setAnchorEl(event.currentTarget)}
                >
                Filter
                </MaterialButton>
                <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<Add />}
                    onClick={() => navigate('/operation/workflow-dictionary/workflow-dictionary-details')}
                >
                    Workflow Dictionary
                </MaterialButton>
            </Stack>
        </Stack>
        )} 
      />
      <CardContent>
          <Table
          columns={fieldDictionaryTable?.columns}
          data={fieldDictionaryTable?.rows}
          actions={actions}
          pagination={{
              totalPages,
              currentPage,
              onPageChange: (page) => handlePaginationChange(page),
              rowsPerPage,
              onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
              rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Workflow Dictionary Data found"
          handleSearch={handleSearch}
          />
      </CardContent>
    </DashboardLayout>
  )
}

export default WorkFlowDictionaryList